import {
  faFile,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFileVideo,
  faFileWord,
  IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export type FileTypeStyle = {
  icon: IconDefinition;
  /** Icon tint, e.g. "text-red-500". */
  iconClass: string;
  /** Tile background, e.g. "bg-red-100". */
  tileClass: string;
};

const DEFAULT_FILE_TYPE_STYLE: FileTypeStyle = {
  icon: faFile,
  iconClass: "text-gray-600",
  tileClass: "bg-gray-100",
};

const red = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-red-500",
  tileClass: "bg-red-100",
});
const green = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-green-600",
  tileClass: "bg-green-100",
});
const indigo = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-indigo-500",
  tileClass: "bg-indigo-100",
});
const sky = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-sky-600",
  tileClass: "bg-sky-100",
});
const pink = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-pink-500",
  tileClass: "bg-pink-100",
});
const gray = (icon: IconDefinition): FileTypeStyle => ({
  icon,
  iconClass: "text-gray-600",
  tileClass: "bg-gray-100",
});

const FILE_TYPE_STYLES: Record<string, FileTypeStyle> = {
  "application/pdf": red(faFilePdf),
  "image/png": indigo(faFileImage),
  "image/jpeg": indigo(faFileImage),
  "image/webp": indigo(faFileImage),
  "text/csv": green(faFileCsv),
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    green(faFileExcel),
  "application/vnd.ms-excel.sheet.macroenabled.12": green(faFileExcel),
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": green(faFileExcel),
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    sky(faFileWord),
  "application/msword": sky(faFileWord),
  "video/mp4": pink(faFileVideo),
  "application/json": gray(faFileCode),
  "text/html": gray(faFileCode),
  "text/plain": gray(faFileLines),
  "application/vnd.ms-outlook": gray(faFileLines),
  "message/rfc822": gray(faFileLines),
};

export const getFileTypeStyle = (
  contentType: string | null | undefined,
): FileTypeStyle =>
  (contentType && FILE_TYPE_STYLES[contentType.toLowerCase()]) ||
  DEFAULT_FILE_TYPE_STYLE;
